<template>

  <!-- Page Sidebar Ends-->
  <div class="page-body">
    <PageTitle title="Employee Gatepass" />

    <div class="rec_count text-danger">
      <ul class="action">
        <li>All : {{gatepass.length}}</li>
        <li>Today : {{filtered_ongoing_pass?.length}}</li>
        <li v-if="user.emprole > 1">Requested : {{requested_pass_count}}</li>
      </ul>

    </div>

    <div class="container-fluid mobile_view" v-if="isMobileView()">

      <div class="col-xxl-12">
        <div class="card">
          <!-- <div class="card-header">
                        <button class="btn btn-secondary" type="button" data-bs-toggle="modal"
                            data-original-title="test" data-bs-target="#EmployeegatepassAdd">Create Gatepass</button>
                    </div> -->
          <div class="card-body">
            <ul class="nav nav-tabs border-tab border-0 mb-0 nav-danger" id="topline-tab" role="tablist">
              <li class="nav-item"><a class="nav-link active nav-border txt-danger nav-danger" id="requested-tab"
                  data-bs-toggle="tab" href="#requested" role="tab" aria-controls="requested" aria-selected="false"><i
                    class="icofont icofont-file-document"></i>Today</a>
              </li>
              <li class="nav-item"><a class="nav-link nav-border pt-0 txt-danger nav-danger" id="all-gatepass-tab"
                  data-bs-toggle="tab" href="#all-gatepass" role="tab" aria-controls="all-gatepass"
                  aria-selected="true"><i class="icofont icofont-man-in-glasses"></i>All</a></li>
              <!--<li class="nav-item"><a class="nav-link nav-border txt-danger nav-danger"-->
              <!--        id="completed-gatepass-tab" data-bs-toggle="tab" href="#completed-gatepass"-->
              <!--        role="tab" aria-controls="completed-gatepass" aria-selected="false"><i-->
              <!--            class="icofont icofont-star"></i>Completed</a></li>-->


              <!--<li> <h6 class="fw-bold">All Gate Pass:</h6></li> -->
              <li>
                <button class="btn btn-primary" type="button" data-bs-toggle="modal" data-original-title="test"
                  data-bs-target="#EmployeegatepassAdd"><i class="icofont icofont-id-card"></i>Create</button>
              </li>

            </ul>




            <div class="tab-content" id="topline-tabContent">
              <div class="tab-pane fade" id="all-gatepass" role="tabpanel" aria-labelledby="all-gatepass-tab">
                <div class="card-body px-0 pb-0">
                  <!--<div class="user-header pb-2">-->
                  <!--    <span class="badge bg-success ms-4 mt-2" v-if="user.empdept==sd || user.emprole==1"  @click="filterlist">Filter</span>-->
                  <!--</div>-->
                  <div class="user-header pb-2">
                    <div class="form-group d-flex align-items-center pb-2 gap-2">
                      <input type="text" v-model="search_text_all" class="form-control" placeholder="Search..." />

                      <span class="badge bg-success" v-if="user.empdept == sd || user.emprole == 1" @click="filterlist"
                        style="cursor: pointer">
                        Filter
                      </span>

                    </div>
                  </div>
                  <div class="user-content">
                    <div class=" ">
                      <div v-for="(item, index) in filtered_getpass" :key="item.gatepassid" class="gatepass-card">
                        <div class="card-header d-flex justify-content-between align-items-center text-white" :class="{
                                                    'bg-warning': item.approval_status==0 ,
                                                    'bg-success': item.approval_status==1,
                                                    'bg-danger': item.approval_status==2
                                                }">
                          <span class=" text-white">#{{ index+1 }} - {{ item.empname }}</span>
                          <!--<input type="checkbox" @click="() => { selectUsers(item.visitor_id) }" :value="item.id" />-->
                        </div>
                        <div class="card-body">
                          <div class="card-header d-flex justify-content-between align-items-center mb-2">
                            <!--<h5 class="mb-0 fw-bold text-primary">#{{ index + 1 }} - {{ item.empname }}</h5>-->
                            <span class="badge bg-info text-white">{{ item.schedule_date }}</span>
                          </div>

                          <div class="card-detail">
                            <p><i class="bi bi-diagram-3-fill me-1"></i><strong>Emp. Code:</strong> {{ item.empcode }}
                            </p>
                            <p><i class="bi bi-diagram-3-fill me-1"></i><strong>Department:</strong> {{ item.dept_name
                              }}</p>
                            <p><i class="bi bi-telephone-fill me-1"></i><strong>Contact:</strong> {{ item.contact }}</p>
                            <p><i class="bi bi-person-fill-up me-1"></i><strong>Requested To:</strong> {{ item.whom_name
                              }}</p>
                            <p><i class="bi bi-person-fill-up me-1"></i><strong>Request Type:</strong> {{ item.req_type
                              }}</p>
                            <p><i class="bi bi-file-earmark-text-fill me-1"></i><strong>Purpose:</strong> {{
                              item.purpose }}</p>
                          </div>

                          <div class="d-flex justify-content-between mt-3 flex-wrap gap-2">
                            <div>
                              <p class="mb-1 fw-semibold">Check Out:</p>
                              <div v-if="user.empdept == sd && item.check_out == null">
                                <button class="btn btn-sm btn-outline-primary"
                                  @click="mark_checkin(item.gatepassid, 2)">Mark Out</button>
                              </div>
                              <div>{{ item.emp_chekout }}
                                <span v-if="item.check_out" class="badge bg-success">{{item.check_out_time}}</span>
                              </div>
                            </div>

                            <div>
                              <p class="mb-1 fw-semibold">Check In:</p>
                              <div v-if="user.empdept == sd && item.check_in == null">
                                <button class="btn btn-sm btn-outline-primary"
                                  @click="mark_checkin(item.gatepassid, 1)">Mark In</button>
                              </div>
                              <div>{{ item.emp_chekin }}
                                <span v-if="item.check_in" class="badge bg-success">{{ item.check_in_time }}</span>
                              </div>
                            </div>
                          </div>

                          <div class="mt-3">
                            <span v-if="item.approval_status == 0" class="badge bg-warning">Pending</span>
                            <span v-else-if="item.approval_status == 1" class="badge bg-success">Accepted</span>
                            <span v-else-if="item.approval_status == 2" class="badge bg-danger">Denied</span>
                          </div>

                          <div class="action-icons mt-3 d-flex gap-3">
                            <button class="btn btn-sm btn-outline-primary" v-if="item.approval_status == 1"
                              @click="getQrCode(item.token)">
                              <i class="icofont icofont-qr-code"></i> QR
                            </button>

                            <i class="icon-trash text-danger" v-if="user.id==item.empid && item.approval_status==0"
                              @click="removeGatepass(item.gatepassid)" title="Delete"></i>

                            <button class="btn btn-sm btn-outline-success"
                              v-if="user.id == item.whom_userid && item.approval_status == 0" @click="accept(item)">
                              <i class="icofont icofont-ui-check"></i> Approve
                            </button>
                            <button class="btn btn-sm btn-outline-danger"
                              v-if="user.id == item.whom_userid && item.approval_status == 0" @click="reject(item)">
                              <i class="icofont icofont-ui-close"></i> Decline
                            </button>

                          </div>
                        <small class="text-muted">{{item.iddate}}</small>
                        </div>
                      </div>
                    </div>


                  </div>
                </div>
              </div>
              
              <div class="tab-pane fade  show active" id="requested" role="tabpanel" aria-labelledby="requested-tab">
                  <!--Today Gatepass-->
                <div class="card-body px-0 pb-0">
                  <div class="user-header pb-2">
                    <div class="form-group d-flex align-items-center pb-2 gap-2">
                      <input type="text" v-model="search_text_today" class="form-control" placeholder="Search..." />


                    </div>
                  </div>
                  <div class="user-content">
                    <div class=" ">
                      <div v-for="(item, index) in filtered_ongoing_pass" :key="item.gatepassid"
                        class="gatepass-card">
                        <div class="card-header d-flex justify-content-between align-items-center text-white" :class="{
                                                    'bg-warning': item.approval_status==0 ,
                                                    'bg-success': item.approval_status==1,
                                                    'bg-danger': item.approval_status==2
                                                }">
                          <span class=" text-white">#{{ index+1 }} - {{ item.empname }}</span>
                          <!--<input type="checkbox" @click="() => { selectUsers(item.visitor_id) }" :value="item.id" />-->
                        </div>
                        <div class="card-body">
                          <div class="card-header d-flex justify-content-between align-items-center mb-2">
                            <!--<h5 class="mb-0 fw-bold text-primary">#{{ index + 1 }} - {{ item.empname }}</h5>-->
                            <span class="badge bg-info text-white">{{ item.schedule_date }}</span>
                          </div>

                          <div class="card-detail">
                            <p><i class="bi bi-diagram-3-fill me-1"></i><strong>Emp. Code:</strong> {{ item.empcode }}
                            </p>
                            <p><i class="bi bi-diagram-3-fill me-1"></i><strong>Department:</strong> {{ item.dept_name
                              }}</p>
                            <p><i class="bi bi-telephone-fill me-1"></i><strong>Contact:</strong> {{ item.contact }}</p>
                            <p><i class="bi bi-person-fill-up me-1"></i><strong>Requested To:</strong> {{ item.whom_name
                              }}</p>
                            <p><i class="bi bi-person-fill-up me-1"></i><strong>Request Type:</strong> {{ item.req_type
                              }}</p>
                            <p><i class="bi bi-file-earmark-text-fill me-1"></i><strong>Purpose:</strong> {{
                              item.purpose }}</p>
                          </div>

                          <div class="d-flex justify-content-between mt-3 flex-wrap gap-2">
                            <div>
                              <p class="mb-1 fw-semibold">Check Out:</p>
                              <div v-if="user.empdept == sd && item.check_out == null">
                                <button class="btn btn-sm btn-outline-primary"
                                  @click="mark_checkin(item.gatepassid, 2)">Mark Out</button>
                              </div>
                              <div>{{ item.emp_chekout }}
                                <span v-if="item.check_out" class="badge bg-success">{{item.check_out_time}}</span>
                              </div>
                            </div>

                            <div>
                              <p class="mb-1 fw-semibold">Check In:</p>
                              <div v-if="user.empdept == sd && item.check_in == null  ">
                                <button class="btn btn-sm btn-outline-primary"
                                  @click="mark_checkin(item.gatepassid, 1)">Mark In</button>
                              </div>
                              <div>{{ item.emp_chekin }}
                                <span v-if="item.check_in" class="badge bg-success">{{ item.check_in_time }}</span>
                              </div>
                            </div>
                          </div>

                          <div class="mt-3">
                            <span v-if="item.approval_status == 0" class="badge bg-warning">Pending</span>
                            <span v-else-if="item.approval_status == 1" class="badge bg-success">Accepted</span>
                            <span v-else-if="item.approval_status == 2" class="badge bg-danger">Denied</span>
                          </div>

                          <div class="action-icons mt-3 d-flex gap-3">
                            <button class="btn btn-sm btn-outline-primary" v-if="item.approval_status == 1"
                              @click="getQrCode(item.token)">
                              <i class="icofont icofont-qr-code"></i> QR
                            </button>

                            <i class="icon-trash text-danger" v-if="user.id==item.empid && item.approval_status==0"
                              @click="removeGatepass(item.gatepassid)" title="Delete"></i>

                            <button class="btn btn-sm btn-outline-success"
                              v-if="user.id == item.whom_userid && item.approval_status == 0" @click="accept(item)">
                              <i class="icofont icofont-ui-check"></i> Approve
                            </button>
                            <button class="btn btn-sm btn-outline-danger"
                              v-if="user.id == item.whom_userid && item.approval_status == 0" @click="reject(item)">
                              <i class="icofont icofont-ui-close"></i> Decline
                            </button>




                          </div>
                        <small class="text-muted">{{item.iddate}}</small>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
              <!--<div class="tab-pane fade" id="completed-gatepass" role="tabpanel"-->
              <!--    aria-labelledby="completed-gatepass-tab">-->
              <!--    <div class="card-body px-0 pb-0">-->
              <!--        <div class="user-header pb-2">-->
              <!--            <h6 class="fw-bold">Completed Gatepass:</h6>-->
              <!--        </div>-->
              <!--        <div class="user-content">-->
              <!--            <div class="table-responsive custom-scrollbar">-->
              <!--                <table class="table display datatable" id="completed">-->
              <!--                    <thead>-->
              <!--                        <tr>-->
              <!--                            <th>Date</th> -->
              <!--                            <th>Employee Name</th>-->
              <!--                            <th>Department</th>-->
              <!--                            <th>Contact</th>-->
              <!--                            <th>Purpose</th> -->
              <!--                            <th>Check Out</th>-->
              <!--                            <th>Check In</th>-->
              <!--                            <th>Exact Check Out</th>-->
              <!--                            <th>Exact Check In</th>-->
              <!--                            <th>Approval</th> -->
              <!--                        </tr>-->
              <!--                    </thead>-->
              <!--                    <tbody>-->
              <!--                        <tr v-for="(item, index)  in completed_pass" :key="item.gatepassid">-->
              <!--                            <td>{{ item.schedule_date }}</td>-->

              <!--                            <td>{{ item.empname }}  </td>-->
              <!--                            <td>{{ item.dept_name }} </td>-->
              <!--                            <td>{{ item.contact }}</td>-->
              <!--                            <td>{{ item.purpose }}  </td>-->

              <!--                            <td>{{ item.emp_chekout }}</td>-->
              <!--                            <td>{{ item.emp_chekin }}</td>-->
              <!--                            <td>{{ item.check_out }}</td>-->
              <!--                            <td>{{ item.check_in }}</td>-->
              <!--                            <td> <div v-if="item.approval_status==0" class="badge bg-warning">Pending</div>-->
              <!--                                <div v-else-if="item.approval_status==1" class="badge bg-success">Accepted</div>-->
              <!--                                <div v-else-if="item.approval_status==2" class="badge bg-danger">Denied</div></td>-->

              <!--                        </tr>-->
              <!--                    </tbody>-->
              <!--                </table>-->
              <!--            </div>-->
              <!--        </div>-->
              <!--    </div>-->
              <!--</div>-->
            </div>
          </div>
        </div>
      </div>
    </div>


    <div v-else class="container-fluid">

      <div class="col-xxl-12">
        <div class="card">
          <!-- <div class="card-header">
                        <button class="btn btn-secondary" type="button" data-bs-toggle="modal"
                            data-original-title="test" data-bs-target="#EmployeegatepassAdd">Create Gatepass</button>
                    </div> -->
          <div class="card-body">
            <ul class="nav nav-tabs border-tab border-0 mb-0 nav-danger" id="topline-tab" role="tablist">
              <li class="nav-item"><a class="nav-link active nav-border txt-danger nav-danger" id="requested-tab"
                  data-bs-toggle="tab" href="#requested" role="tab" aria-controls="requested" aria-selected="false"><i
                    class="icofont icofont-file-document"></i>Today</a>
              </li>
              <li class="nav-item"><a class="nav-link nav-border pt-0 txt-danger nav-danger" id="all-gatepass-tab"
                  data-bs-toggle="tab" href="#all-gatepass" role="tab" aria-controls="all-gatepass"
                  aria-selected="true"><i class="icofont icofont-man-in-glasses"></i>All</a></li>
              <!--<li class="nav-item"><a class="nav-link nav-border txt-danger nav-danger"-->
              <!--        id="completed-gatepass-tab" data-bs-toggle="tab" href="#completed-gatepass"-->
              <!--        role="tab" aria-controls="completed-gatepass" aria-selected="false"><i-->
              <!--            class="icofont icofont-star"></i>Completed</a></li>-->


              <!--<li> <h6 class="fw-bold">All Gate Pass:</h6></li> -->
              <li>
                <button class="btn btn-primary" type="button" data-bs-toggle="modal" data-original-title="test"
                  data-bs-target="#EmployeegatepassAdd">Create Gatepass</button>
              </li>

            </ul>

            <!-- <span class="badge bg-success ms-4 mt-2"  @click="filterlist">Filter</span> -->


            <div class="tab-content" id="topline-tabContent">
              <div class="tab-pane fade" id="all-gatepass" role="tabpanel" aria-labelledby="all-gatepass-tab">
                <div class="card-body px-0 pb-0">
                  <div class="user-header pb-2">
                  </div>
                  <div class="user-content">
                    <div class="table-responsive custom-scrollbar">
                      <table class="table display  " id="All">
                        <thead>
                          <tr>
                            <th>Sr</th>
                            <th>Date</th>
                            <th>Employee Name</th>
                            <th>Department</th>
                            <th>Contact</th>
                            <th>Requested To</th>
                            <th>Request Type</th>
                            <th>Purpose</th>
                            <th>Check Out</th>
                            <th>Check In</th>
                                                        <th>Actual Check Out</th>
                                                        <th>Actual Check In</th>
                            <th>Approval Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index)  in gatepass" :key="item.gatepassid">
                            <td>{{ index+1 }} </td>
                            <td>{{ item.schedule_date }}</td>

                            <td>{{ item.empname }} </td>
                            <td>{{ item.dept_name }} </td>
                            <td>{{ item.contact }}</td>
                            <td>{{ item.whom_name }} </td>
                            <td>{{ item.req_type }} </td>
                            <td>{{ item.purpose }} </td>
                            <td>
                             
                              <div>
                                {{ item.emp_chekout }} 
                              </div>
                            </td>

                            <td> 
                              <div>
                                {{ item.emp_chekin }} 
                              </div>

                            </td>

                                                        <td>
                                                                  <div
                                                                        v-if="user.empdept == sd && item.check_out == null  ">
                                                                        <button title="Mark Checkout" class="btn btn-primary"
                                                                            @click="mark_checkin(item.gatepassid, 2)">Check
                                                                            Out</button>
                                                                    </div>
                                                                    <div v-else><span v-if="item.check_out" class="badge bg-success">{{item.check_out_time}}</span></div>
                                                        </td>
                                                       
                                                        <td>
                                                          <div v-if="user.empdept == sd && item.check_in == null">
                                                                <button title="Mark Check In" class="btn btn-primary"
                                                                    @click="mark_checkin(item.gatepassid, 1)">Check
                                                                    In</button>
                                                            </div>
                                                            <div v-else><span v-if="item.check_in" class="badge bg-success">{{item.check_in_time}}</span></div>

                                                        </td>


                            <td>
                              <div v-if="item.approval_status==0" class="badge bg-warning">Pending</div>
                              <div v-else-if="item.approval_status==1" class="badge bg-success">Accepted</div>
                              <div v-else-if="item.approval_status==2" class="badge bg-danger">Denied</div>
                            </td>
                            <td>
                              <ul class="action">

                                <li class="link" @click="getQrCode(item.token)"><i class="icofont icofont-qr-code"></i>
                                </li> &nbsp;
                                <li class="delete" v-if="user.id==item.empid && item.approval_status==0"
                                  @click="removeGatepass(item.gatepassid)"><i class="icon-trash"></i></li> &nbsp;
                                <li v-if="user.id==item.whom_userid && item.approval_status==0" title="Approve"
                                  class="link" @click="accept(item)">
                                  <i class="icofont icofont-ui-check text-success"></i>
                                </li>
                                &nbsp;
                                <li v-if="user.id==item.whom_userid && item.approval_status==0" title="Decline"
                                  @click="reject(item)">
                                  <i class="icofont icofont-ui-close text-danger"></i>
                                </li>
                              </ul>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
    <div class="tab-pane fade  show active" id="requested" role="tabpanel" aria-labelledby="requested-tab">
                                <div class="card-body px-0 pb-0">
                                    <div class="user-header pb-2">
                                        <!--<h6 class="fw-bold">Pending For Approval:</h6>-->
                                    </div>
                                    <div class="user-content">
                                        <div class="table-responsive custom-scrollbar">
                                            <table class="table display  " id="pending">
                                                <thead>
                                                    <tr>
                                                        <th>Sr</th> 
                                                        <th>Date</th> 
                                                        <th>Employee Name</th>
                                                        <th>Department</th>
                                                        <th>Contact</th>
                                                        <th>Requested To</th>
                                                        <th>Request Type</th>
                                                        <th>Purpose</th> 
                                                        <th>Check Out</th>
                                                        <th>Check In</th>
                                                        <th>Actual Check Out</th>
                                                        <th>Actual Check In</th>
                                                        <th>Approval</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, index)  in filtered_ongoing_pass" :key="item.gatepassid">
                                                        <td>{{ index+1 }}</td>
                                                        <td>{{ item.schedule_date }}</td>
                                                       
                                                        <td>{{ item.empname }}  </td>
                                                        <td>{{ item.dept_name }} </td>
                                                        <td>{{ item.contact }}</td>
                                                        <td>{{ item.whom_name }}  </td>
                                                        <td>{{ item.req_type }}  </td> 
                                                        <td>{{ item.purpose }}  </td>
                                                         
                                                       <!-- <td>{{ item.emp_chekout }}</td>
                                                        <td>{{ item.emp_chekin }}</td>
                                                    -->
                                                        <td>
                                                            
                                                            <div>    
                                                            {{ item.emp_chekout }}
                                                            
                                                            </div>
                                                        </td>
                                                       
                                                        <td>
                                                            
                                                            <div>    
                                                                {{ item.emp_chekin }}
                                                                  
                                                            </div>

                                                        </td>


                                                        <td>
                                                                  <div
                                                                        v-if="user.empdept == sd && item.check_out == null  ">
                                                                        <button title="Mark Checkout" class="btn btn-primary"
                                                                            @click="mark_checkin(item.gatepassid, 2)">Check
                                                                            Out</button>
                                                                    </div>
                                                                    <div v-else><span v-if="item.check_out" class="badge bg-success">{{item.check_out_time}}</span></div>
                                                        </td>
                                                       
                                                        <td>
                                                          <div v-if="user.empdept == sd && item.check_in == null">
                                                                <button title="Mark Check In" class="btn btn-primary"
                                                                    @click="mark_checkin(item.gatepassid, 1)">Check
                                                                    In</button>
                                                            </div>
                                                            <div v-else><span v-if="item.check_in" class="badge bg-success">{{item.check_in_time}}</span></div>

                                                        </td>



                                                        <td> <div v-if="item.approval_status==0" class="badge bg-warning">Pending</div>
                                                            <div v-else-if="item.approval_status==1" class="badge bg-success">Accepted</div>
                                                            <div v-else-if="item.approval_status==2" class="badge bg-danger">Denied</div>
                                                            </td>
                                                        <td>
                                                            
                                                            <ul class="action">
                                                                <li class="delete"  v-if="user.id==item.empid && item.approval_status==0"
                                                                    @click="removeGatepass(item.gatepassid)"><i
                                                                        class="icofont icofont-ui-delete"></i></li>
                                                                        &nbsp;
                                                                <li class="link" @click="getQrCode(item.token)"><i
                                                                        class="icofont icofont-qr-code"></i></li> &nbsp;
                                                                <li v-if="user.id==item.whom_userid && item.approval_status==0" title="Approve" class="link" @click="accept(item)">
                                                                    <i class="icofont icofont-ui-check text-success"></i></li>
                                                                &nbsp;
                                                                <li v-if="user.id==item.whom_userid && item.approval_status==0"  title="Decline" @click="reject(item)">
                                                                <i class="icofont icofont-ui-close text-danger"></i>
                                                                </li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>





  <!-- filterModel -->




  <div class="modal" v-if="showfilterModel" style="display: block; background-color: rgba(0,0,0,0.5);" tabindex="-1"
    role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Filter</h5>
          <button type="button" class="close" @click="showfilterModel = false" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">

          <div class="col-12 row">


            <div class="col-6">
              <label class="form-label">From Date</label>
              <input class="form-control" type="date" v-model="filter.fromdate" placeholder="Type Here..." required>
            </div>

            <div class="col-6">
              <label class="form-label">To Date</label>
              <input class="form-control" type="date" v-model="filter.todate" placeholder="Type Here..." required>
            </div>
          </div>

          <div class="col-12 row">

            <!-- <div class="col-6 mt-2">
                        <label class="form-label">Employee Name</label>
                        <select class="form-control" v-model="filter.empid" required>
                            <option value="0">All</option>
                            <option v-for="item in empname" :key="item.id" :value="item.id">
                                {{ item.empname }} / {{ item.contact }}
                            </option>
                        </select>
                    </div> -->

            <div class="col-6 mt-2">
              <label class="form-label">Employee Name</label>
              <Autocomplete :items="empname" labelField="empname" valueField="id" placeholder="Search Employee"
                @select="handleSelectEmp" />
            </div>



            <!-- <div class="col-6 mt-2">
                            <label class="form-label">Department Name</label>
                            <select class="form-control" v-model="filter.deptid" required>
                                <option value="0">All</option>
                                <option v-for="item in departments" :key="item.id" :value="item.id">
                                    {{ item.departments }} 
                                </option>
                            </select>
                            </div>


                            </div> -->


            <div class="col-6 mt-2">
              <label class="form-label">Department Name</label>

              <Autocomplete :items="departments" labelField="deptname" valueField="id" placeholder="Search Department"
                @select="handleSelectDepartment" />
            </div>



          </div>






        </div>
        <div class="modal-footer">

          <button type="button" class="btn btn-primary" @click="getfilterlist">Search</button>
        </div>
      </div>
    </div>
  </div>
















  <!-- filterModel -->














  <div class="modal fade" id="qrcodeView" tabindex="-1" role="dialog" aria-labelledby="qrcodeView" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">QR Code</h4>
          <button class="btn-close py-0" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="modal-toggle-wrapper ">
            <div class="col-sm-12">
              <canvas ref="qrcodeCanvas"></canvas>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="col-12">

          </div>
        </div>
      </div>
    </div>
  </div>
  <ModalsPart v-if="!['login'].includes($route.name)" @getGateEmpPassData="updateData" />
</template>
<style scoped>
  .avatar {
    width: 50px;
    border-radius: 30px;
  }

  .card-title {
    font-size: 1.1rem;
    font-weight: bold;
  }

  .card {
    border-radius: 0.75rem;
  }

  .card-body p,
  .card-body h5 {
    margin-bottom: 0.25rem;
    /* Reduced spacing */
  }

  .gatepass-card {
    background: #fff;
    border-radius: 1rem;
    margin-bottom: 1.5rem;
    border: 1px solid gray;
    transition: all 0.3s ease-in-out;
  }

  .gatepass-card:hover {
    transform: scale(1.01);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
  }

  .card-header {
    border-bottom: 1px solid #eee;
  }

  .card-detail p {
    margin-bottom: 0.4rem;
    color: #444;
  }

  .action-icons i {
    font-size: 1.2rem;
    cursor: pointer;
  }

  .action-icons i:hover {
    transform: scale(1.2);
    transition: 0.2s;
  }

  .action {
    gap: 20px;
  }
</style>
<script>
  // @ is an alias to /src 
  import PageTitle from '@/components/PageTitle.vue';
  import ModalsPart from '@/components/Modals.vue';
  import GatePass from '@/components/GatepassPrint.vue';
  // import axios from 'axios';
  import axios from "@/plugins/axios";
  import QRCode from 'qrcode';

  export default {
    name: 'CreateEmployeeGatepass',
    components: {
      PageTitle, ModalsPart, GatePass
    }, mounted() {
      if (this.$route.query.visitorid)
        this.getBasics({ isVisitor: this.$route.query.visitorid });
      else
        this.getBasics();

    },
    beforeUnmount() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        console.log('Interval cleared');
      }
    }, data() {
      return {
        gatepass: [],
        requested_pass: [],
        completed_pass: [],
        rooms: [],
        room_booking_visitor: [],
        selected_room: { 'roomid': 0, 'gatepassid': 0, 'schedule_date': '', 'schedule_time': '' },
        user: [],
        empname: [],
        departments: [],
        sd: 0,
        filter: {

          fromdate: this.todayDate(),
          todate: this.todayDate(),
          empid: '',
          deptid: '',


        },
        //   departments:[],


        showfilterModel: false,
        isLiveStarted: false,
        lastupdate: null,
        intervalId: null,


        filtered_ongoing_pass: [],
        filtered_getpass: [],
        search_text_today: '',
        search_text_all: '',
        requested_pass_count:0,

      }
    },
    watch: {
      search_text_today(newVal) {
        this.onSearchTypeToday(newVal);
      },
      search_text_all(newVal) {
        this.onSearchTypeAll(newVal);

      },

      ongoing_pass(newVal) {
        if (newVal) this.filtered_ongoing_pass = newVal;

      },

      gatepass(newVal) {
        if (newVal) this.filtered_getpass = newVal;

      },

    },
    methods: {

      updateData() {
        this.getBasics();
      },
      getBasics(filter = []) {
        var self = this;
        axios.post('getEmpGatepass', filter).then(function (response) {
          self.destroyTable();
          self.gatepass = response.data.gatepass; // all gatepass
          self.ongoing_pass = response.data.ongoing_pass; // todays
          self.empname = response.data.empname;
          self.filtered_ongoing_pass = self.ongoing_pass;
          self.filtered_getpass=self.gatepass;
            self.requested_pass_count = response.data.requested_pass_count;
          
          self.departments = response.data.deptname;
          self.rooms = response.data.rooms;
          self.user = response.data.user;
          self.sd = response.data.sd;

          if (!self.isLiveStarted) {
            self.isLiveStarted = true;
            self.intervalId = setInterval(self.refreshGatepass, 10000);
          }


          //  window.scrollTo(0, 0);
        }).then(() => {
          self.refreshTable();
        });
      },
      removeGatepass(id) {
        var self = this;
        self.$swal({
          title: "Do You Want To Delete?",
          text: "Are you sure? You won't be able to revert this!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Yes, Delete it!"
        }).then((result) => { // <--
          if (result.value) { // <-- if confirmed
            axios.post('removeEmpGatepass', { gatepass_id: id }).then(function (response) {
              self.destroyTable();
              self.gatepass = response.data.gatepass;
                self.ongoing_pass = response.data.ongoing_pass;
                
                  self.filtered_ongoing_pass = self.ongoing_pass;
                  self.filtered_getpass=self.gatepass;
            self.requested_pass_count = response.data.requested_pass_count;
              //  window.scrollTo(0, 0);
            }).then(() => {
              self.refreshTable();
            });
          }
        });

      },
      containsKey(obj, key) {
        return Object.keys(obj).includes(key);
      }
      ,
      mark_checkin(passid, what) {
        var self = this;
        self.$swal({
          title: "Do You Want To Proceed ?",
          text: "Just For Confirmation !",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Yes"
        }).then((result) => { // <--
          if (result.value) { // <-- if confirmed
            axios.post('checkInEmployee', { passid: passid, what: what }).then(function (response) {
              self.destroyTable();


              self.$swal(response.data.msg);
              // }else{
              if (response.data.is == 1) {
                self.gatepass = response.data.gatepass;
                // self.completed_pass = response.data.completed_pass;
                self.ongoing_pass = response.data.ongoing_pass;
                // self.ongoing_pass = response.data.ongoing_pass;
                
                  self.filtered_ongoing_pass = self.ongoing_pass;
                  self.filtered_getpass=self.gatepass;
            self.requested_pass_count = response.data.requested_pass_count;
          
                self.rooms = response.data.rooms;
                self.user = response.data.user;

              }

            }).then(() => {
              self.refreshTable();
            });
          }
        });

      },
      accept(visit) {
        var self = this;
        self.$swal({
          title: "Do You Want To Accept?",
          text: "Just For Confirmation !",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Yes"
        }).then((result) => { // <--
          if (result.value) { // <-- if confirmed
            axios.post('acceptEmpGatepass', { gatepass_id: visit.gatepassid }).then(function (response) {
              
              if(response.data.is==1){
                  self.destroyTable();
                  self.gatepass = response.data.gatepass;
                //   self.completed_pass = response.data.completed_pass;
                //   self.requested_pass = response.data.requested_pass;
                    self.ongoing_pass = response.data.ongoing_pass;
                    self.filtered_ongoing_pass = self.ongoing_pass;
                    self.filtered_getpass=self.gatepass;
            self.requested_pass_count = response.data.requested_pass_count;
              } 
                  self.$swal(response.data.msg);
               
              //  window.scrollTo(0, 0);
            }).then(() => {
              self.refreshTable();
            });
          }
        });

      },
      reject(visit) {
        var self = this;
        self.$swal({
          title: "Do You Want To Decline?",
          text: "Just For Confirmation !",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Yes"
        }).then((result) => { // <--
          if (result.value) { // <-- if confirmed
            axios.post('declineEmpGatepass', { gatepass_id: visit.gatepassid }).then(function (response) {
              self.destroyTable();
              self.gatepass = response.data.gatepass;
              self.completed_pass = response.data.completed_pass;
              self.requested_pass = response.data.requested_pass;
              //  window.scrollTo(0, 0);
            }).then(() => {
              self.refreshTable();
            });
          }
        });

      },
      async getQrCode(token) {
        try {
          if (token.length > 0) {
            const canvas = this.$refs.qrcodeCanvas;
            var url = this.$api_host + 'empg?q=' + token;
            await QRCode.toCanvas(canvas, url, { width: 200 });
            $("#qrcodeView").modal("toggle");
          }

        } catch (error) {
          console.error(error);
        }
      },
      getImageUrl(image) {
        return `${this.$hostname}/writable/visitors/${image}`;
      },





      destroyTable() {
        if ($.fn.dataTable.isDataTable('#All')) {
          $('#All').DataTable().destroy();
        }
        if ($.fn.dataTable.isDataTable('#pending')) {
          $('#pending').DataTable().destroy();
        }
        if ($.fn.dataTable.isDataTable('#completed')) {
          $('#completed').DataTable().destroy();
        }
      },
      refreshTable() {
        var self = this;
        $("#All").DataTable({
          dom: 'Bfrtip',
          buttons: ['excel', 'pdf', {
            text: 'Filter',
            action: function (e, dt, node, config) {
              self.filterlist();
            }
          }],
          "paging": true,
          "ordering": true,
          "autoWidth": false,
          "aaSorting": []
        });

        $("#pending").DataTable({
          dom: 'Bfrtip',
          buttons: ['excel', 'pdf'],
          "paging": true,
          "ordering": true,
          "autoWidth": false,
          "aaSorting": []
        });
        $("#completed").DataTable({
          dom: 'Bfrtip',
          buttons: ['excel', 'pdf'],
          "paging": true,
          "ordering": true,
          "autoWidth": false,
          "aaSorting": []
        });

      },

      filterlist() {


        this.showfilterModel = true;


      },


      todayDate() {
        var today = new Date();
        var month = today.getMonth() + 1;

        return today.getFullYear() + '-' + ((month < 10) ? '0' + month : month) + '-' + ((today.getDate() < 10) ? '0' + today.getDate() : today.getDate());//today.getDate();;

      },



      getfilterlist() {
        var self = this;
        axios.post('getFilterEmpGatepass', self.filter).then(function (response) {
          self.destroyTable();
          self.gatepass = response.data.gatepass;
          self.completed_pass = response.data.completed_pass;
          self.requested_pass = response.data.requested_pass;
           
          // self.empname = response.data.empname;
          // self.departments = response.data.departments;
          self.rooms = response.data.rooms;
          self.user = response.data.user;
          self.showfilterModel = false;

          self.status = response.data.status;

          if (self.status == 1) {

            self.showfilterModel = false;
            self.filter = {
              fromdate: self.todayDate(),
              todate: self.todayDate(),
              empid: '',
              deptid: ''
            };

          }


        }).then(() => {
          self.refreshTable();
        });
      },




      //06.05.2025
      isMobileView() {
        if (window.innerWidth <= 768) {
          //   alert("Yes");
          return true;
        } else {
          // alert("No");
          return false;
        }
      },

      handleSelectEmp(selectedId) {
        this.filter.empid = selectedId.id;
      },

      handleSelectDepartment(departmentId) {
        // console.log(departmentId);
        this.filter.deptid = departmentId.id;
      },
      //13.05.2025
      refreshGatepass() {
        var self = this;
        var havedata = false;
        axios.post('getEmpGatepassUpdated').then(function (response) {
          if (response.data.requested_pass && response.data.requested_pass.length > 0) {
            havedata = true;
            self.destroyTable();
            // self.gatepass = response.data.gatepass; 
            //  self.requested_pass = response.data.requested_pass; 
            self.filtered_ongoing_pass = response.data.requested_pass;
            self.requested_pass_count = response.data.requested_pass_count;
          }
        }).then(() => {
          if (havedata)
            self.refreshTable();
        });

      },
      onSearchTypeToday(query) {
        if (query) {
          this.filtered_ongoing_pass = this.ongoing_pass.filter(item =>
            item.empname.toLowerCase().includes(query.toLowerCase())
          );
        } else {
          this.filtered_ongoing_pass = this.ongoing_pass;
        }

      }
      ,
      onSearchTypeAll(query) {
        if (query) {
          this.filtered_getpass = this.gatepass.filter(item =>
            item.empname.toLowerCase().includes(query.toLowerCase())
          );
        } else {
          this.filtered_getpass = this.gatepass;
        }
      }





    }
  }
</script>